<template>
    <div id="footer" class="footer" style="background-color: #181818;">
        <div class="background8">
            <div class="container">
                <ul class="ulSections">
                    <router-link :to="{name: 'home'}"><li class="liSections" >{{$t('home')}} </li></router-link>
                    <router-link :to="{name: 'categories'}"><li class="liSections">{{$t('categories')}} </li></router-link>
                    <router-link :to="{name: 'news'}"><li class="liSections" >{{$t('news')}} </li></router-link>
                    <router-link :to="{name: 'albums'}"><li class="liSections">{{$t('albums')}} </li></router-link>
                    <router-link :to="{name: 'contact'}"><li class="liSections">{{$t('contact')}} </li></router-link>
                    <router-link :to="{name: 'about'}"><li class="liSections">{{$t('about')}} </li></router-link>
                </ul>
                <div class="footercheese-section">
                    <p class="footerText">{{$t('footer.footerText')}}</p>
                    <ul class="ulConactUs">
                        <div v-if="getContacts.phone">
                            <i class="fas fa-mobile-alt"></i>
                            <li class="liConactUs" style="vertical-align: middle;">{{$t('common.phone1')}} 
                                <a class="link-contact" :href="'tel:' + getContacts.phone" target="_blank" rel="noopener noreferrer">
                                    {{ getContacts.phone }}
                                </a>
                            </li>
                        </div>
                        <div v-if="getContacts.mobile">
                            <i class="fas fa-mobile-alt"></i>
                            <li class="liConactUs" style="vertical-align: middle;">{{$t('common.phone2')}} 
                                <a class="link-contact" :href="'tel:' + getContacts.mobile" target="_blank" rel="noopener noreferrer">
                                    {{ getContacts.mobile }}
                                </a>
                            </li>
                        </div>
                         <div v-if="getContacts.whatsapp">
                            <i class="fas fa-mobile-alt"></i>
                            <li class="liConactUs" style="vertical-align: middle;">{{$t('common.phone3')}} 
                                <a class="link-contact" :href="'tel:' + getContacts.whatsapp" target="_blank" rel="noopener noreferrer">
                                    {{ getContacts.whatsapp }}
                                </a>
                            </li>
                        </div>
                    </ul>
                    <div class="social-media">
                        <a v-if="getContacts.facebook" :href="getContacts.facebook" target="_blank" rel="noopener noreferrer">
                            <i class="fab fa-facebook mr-3"></i>
                        </a>
                        <a v-if="getContacts.instagram" :href="getContacts.instagram" target="_blank" rel="noopener noreferrer">
                            <i class="fab fa-instagram mr-3"></i>
                        </a>
                        <a v-if="getContacts.telegram" :href="getContacts.telegram" target="_blank" rel="noopener noreferrer">
                            <i class="fab fa-telegram mr-2"></i>
                        </a>
                    </div>
                </div>
                <router-link :to="{name: 'home'}">
                    <img src="/images/logo.png" class="footer-img1">
                </router-link>
            </div>
        </div>
        <div class="container" style="background-color: #181818;padding-bottom: 10px">
            <div class="row">
                <div class="col d-flex flex-column justify-content-center text-white">
                    <span class="font-weight-light text-align-start">
                        <span class="d-inline d-md-none">{{$t('footer.copyright')}}</span>
                        ©
                        <span class="d-none d-md-inline">{{$t("footer.rights-reserved")}}</span>
      
                    </span>
                </div>
                <div class="col-3 text-center">
                    <a class="back-to-top" href="#">
                        <span class="fa fa-chevron-up text-white"></span>
                    </a>
                </div>
                <div class="col  d-flex flex-column">
                    <p class="credit text-end mb-0 px-4">
                        <span class="d-none text-orange d-md-inline">
                           {{ $t('footer.powered-by')}}
                        </span>

                        <a href="https://beetronix.com" target="_blank">
                            <img class="d-none d-md-inline" src="/images/beetronix-logo-tiny.png" height="40">
                            <img class="d-inline d-md-none" src="/images/beetronix-logo-without-text-172.png" height="40">
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'pageFooter',
	computed: {
		...mapGetters({
			getContacts: 'branches/getContacts'
		})
	}
}
</script>

<style scoped>
.link-contact {
    color: #ffffff;
    text-decoration: none;
    display: inline-block;
}
.link-contact:hover {
    text-decoration: underline !important;
    cursor: pointer;
}
</style>